import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'GetLotteryPromotions',
            headers: {},
            args: {
                ...payload,
            },
        });

        return result;
    };
};
